/*
 * Copyright (c) 2022.  Shivangi Gami
 * All Rights Reserved
 */

export const IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST =
  'IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST';
export const IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST_SUCCESS =
  'IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST_SUCCESS';
export const IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST_FAILURE =
  'IN_USE_TAG_FILTER_IN_CLIENT_FETCH_REQUEST_FAILURE';

export const IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST = 'IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST';
export const IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST_SUCCESS =
  'IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST_SUCCESS';
export const IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST_FAILURE =
  'IN_USE_TAG_FILTER_IN_TASK_FETCH_REQUEST_FAILURE';

export const ADD_NEW_TASK_TAG_REQUEST = 'ADD_NEW_TAG_REQUEST';
export const ADD_NEW_TASK_TAG_REQUEST_SUCCESS = 'ADD_NEW_TAG_REQUEST_SUCCESS';
export const ADD_NEW_TASK_TAG_REQUEST_FAILURE = 'ADD_NEW_TAG_REQUEST_FAILURE';

export const DELETE_TASK_TAG_REQUEST = 'DELETE_TASK_TAG_REQUEST';
export const DELETE_TASK_TAG_REQUEST_SUCCESS = 'DELETE_TASK_TAG_REQUEST_SUCCESS';
export const DELETE_TASK_TAG_REQUEST_FAILURE = 'DELETE_TASK_TAG_REQUEST_FAILURE';

export const TAG_CLIENT_FETCH_REQUEST = 'TAG_CLIENT_FETCH_REQUEST';
export const TAG_CLIENT_FETCH_REQUEST_SUCCESS = 'TAG_CLIENT_FETCH_REQUEST_SUCCESS';
export const TAG_CLIENT_FETCH_REQUEST_FAILURE = 'TAG_CLIENT_FETCH_REQUEST_FAILURE';

export const TAG_LIST_FETCH_REQUEST = 'TAG_LIST_FETCH_REQUEST';
export const TAG_LIST_FETCH_REQUEST_SUCCESS = 'TAG_LIST_FETCH_REQUEST_SUCCESS';
export const TAG_LIST_FETCH_REQUEST_FAILURE = 'TAG_LIST_FETCH_REQUEST_FAILURE';

export const TAG_CLIENT_UPSERT_REQUEST = 'TAG_CLIENT_UPSERT_REQUEST';
export const TAG_CLIENT_UPSERT_REQUEST_SUCCESS = 'TAG_CLIENT_UPSERT_REQUEST_SUCCESS';
export const TAG_CLIENT_UPSERT_REQUEST_FAILURE = 'TAG_CLIENT_UPSERT_REQUEST_FAILURE';

export const MERGE_TAGS_REQUEST = 'MERGE_TAGS_REQUEST';
export const MERGE_TAGS_REQUEST_SUCCESS = 'MERGE_TAGS_REQUEST_SUCCESS';
export const MERGE_TAGS_REQUEST_FAILURE = 'MERGE_TAGS_REQUEST_FAILURE';

export const CLEAN_TAG_PROPS = 'CLEAN_TAG_PROPS';
